import { Box, ColorOptions, IconNew as Icon, Text, useWindowDimensions } from '@jfs/ui-new'
import React, { FC } from 'react'
import { SearchBarTypes } from '.'
import { generateRandomString } from '../../utils'
import { styles } from './styles'

interface SearchListItemProps {
  data: any
  onPress?: (data: any) => void
  isRecents?: boolean
  type?: SearchBarTypes
}

// const keyExtractor = (item: any): string => {
//   return item.id
// }

const SearchListItem: FC<SearchListItemProps> = ({ data, onPress = () => {} }: SearchListItemProps) => {
  const window = useWindowDimensions()

  const handlePress = () => onPress(data)
  return (
    <Box
      underlayColor="TRANSPARENT"
      {...styles(window).searchItemContainer}
      flexDirection="row"
      onPress={handlePress}
      key={generateRandomString(2)}>
      <Box {...styles(window).searchListItemStyle}>
        <Box borderRadius={2} ph={8} pv={4} bg={'#0000000F' as ColorOptions}>
          <Text type="h5" {...styles(window).searchSubTitleText()}>
            {data?.item?.filterKey}
          </Text>
        </Box>
        <Box position={'absolute'} left={132}>
          <Text type="h5" {...styles(window).searchSubTitleText()}>
            {data?.item?.searchString}
          </Text>
        </Box>
      </Box>
      <Box alignSelf="center">
        <Icon id={'ARROW_RIGHT'} color={'BLUE'} size={20} />
      </Box>
    </Box>
  )
}

export { SearchListItem }
